export const useInventory = (data) => {
    const filteredProducts = data.raw.items.filter(
        (product) => product.__typename === 'ConfigurableCartItem' || product.__typename === 'BundleCartItem',
    );

    const filteredCustomisationCosts = data.raw.items.filter((product) => product.__typename === 'VirtualCartItem');

    const productCosts = filteredProducts
        .map((item) => item.prices.row_total.value - (item.prices?.discounts?.[0].amount.value || 0))
        .reduce((previousNr, nextNr) => previousNr + nextNr, 0);

    filteredCustomisationCosts.shift();

    const setupCost = data.items?.filter((el) => el?.product.sku === 'setup_charge')[0]?.prices?.price || 0;

    const setupCostDiscount =
        data.raw.items
            ?.filter((el) => el?.prices?.discounts !== null && el?.product.sku === 'setup_charge')
            .map((el) => el?.prices?.discounts)[0]
            ?.map((el) => el?.amount)[0].value || 0;

    const setupCostAfterDiscount = setupCost - setupCostDiscount;

    const oneTimeSetupFee = setupCostAfterDiscount > 0 ? setupCostAfterDiscount : setupCost;

    const logoCosts =
        filteredCustomisationCosts
            ?.map((cost) => cost.prices.row_total.value - (cost.prices?.discounts?.[0]?.amount.value || 0))
            .reduce((previousNr, nextNr) => previousNr + nextNr, 0) || 0;

    const discount = data.totals.discounts?.[0]?.amount;

    const totalExVat = data.totals.subtotal_excluding_tax - (discount || 0);
    const deliveryCost = data.raw.shipping_addresses?.[0]?.selected_shipping_method?.price_incl_tax?.value || 0;
    const vatItem = data.totals.applied_taxes?.[0] || 0;
    const vat = vatItem.label && vatItem.label === 'VAT' ? vatItem.amount : 0;
    const totalIncVat = data.totals.grand_total;

    const selectedShippingCountryCode = data.raw.shipping_addresses?.[0]?.country?.code;
    const shouldShowDuty =
        selectedShippingCountryCode === undefined || selectedShippingCountryCode.toUpperCase() === 'IE';
    const duty = shouldShowDuty ? data.raw.duty?.duty : undefined;
    const dutyNet = shouldShowDuty ? data.raw.duty?.duty_net : undefined;
    const dutyVat = shouldShowDuty && duty !== undefined && dutyNet !== undefined ? duty - dutyNet : undefined;

    const inventoryRows = [
        ['Product Costs', productCosts, 'SummaryTable_item_ProductCosts'],
        ['Costs To Add Logo', logoCosts, 'SummaryTable_item_ApplicationCosts'],
        ['One Time Setup Fees', oneTimeSetupFee, 'SummaryTable_item_Fees', 'tooltip'],
        ['Total,(exc. VAT)', totalExVat, 'SummaryTable_item_total-ex-vat'],
        ['VAT (on Total)', vat, 'SummaryTable_item_VAT'],
        ['Duty (exc. VAT)', dutyNet, 'SummaryTable_item_Duty'],
        ['VAT (on Duty)', dutyVat, 'SummaryTable_item_Duty'],
        ['Delivery (inc. VAT)', deliveryCost, 'SummaryTable_item_shipping'],
        ['Total Discount', discount, 'SummaryTable_total_discount', 'discount'],
        ['Your total,(inc. VAT)', totalIncVat, 'SummaryTable_item_grand-total', 'total'],
    ];

    return inventoryRows.filter((row) => row[1]);
};
